import { textoEstadoVenta } from "../../servicios/ventasReportesUtils";

const VentasEstados = ({ estados, filters, disabled }) => {
  const maximo = Math.max(1, ...estados.map((item) => item.Cantidad));

  return (
    <section className="ventas-panel" aria-labelledby="ventas-estados-titulo">
      <div className="ventas-panel-titulo"><div><h3 id="ventas-estados-titulo">Estado de las ventas</h3><p>Volumen en cada etapa operativa</p></div><ExportarReporte endpoint="PISeunReportes/VentasEstados" filters={filters} nombre="Estados de ventas" disabled={disabled} /></div>
      <div className="ventas-embudo">
        {estados.map((item) => (
          <div className="ventas-estado" key={item.Estado}>
            <span>{textoEstadoVenta(item.Estado)}</span>
            <span className="ventas-estado-barra" aria-hidden="true"><i style={{ width: `${(item.Cantidad / maximo) * 100}%` }} /></span>
            <strong>{item.Cantidad.toLocaleString("es-AR")}</strong>
          </div>
        ))}
      </div>
    </section>
  );
};

export default VentasEstados;
import ExportarReporte from "../ExportarReporte/ExportarReporte";
